import { Paper, SxProps, Table, TableBody, TableContainer } from '@mui/material'

import { useStickyHeaderStyles } from 'components/Table'
import { MIN_ESTIMATED_STICKY_ROWS } from 'components/Table/Table/components/useStickyHeaderStyles'
import { theme } from 'providers/material-ui'
import { TABLE_BORDER } from './constants'
import { Rows } from './Rows'
import { TableData, VariantsTableProps } from './types'
import { composeTableData } from './utils'

export const VariantsTable = ({
  schema,
  values,
  variant,
  workspaceValues,
}: VariantsTableProps): React.JSX.Element => {
  const data: TableData = composeTableData(schema, values, workspaceValues, Object.keys(values))

  const sx: SxProps = {
    backgroundColor: theme.palette.background.default,
    border: TABLE_BORDER,
  }

  const tableContainerStickyStyles = useStickyHeaderStyles({
    headerGroups: 1,
    variant: 'tableContainer',
  })

  return (
    <TableContainer
      component={Paper}
      sx={data.rows.length > MIN_ESTIMATED_STICKY_ROWS ? tableContainerStickyStyles : {}}
    >
      <Table>
        <TableBody>
          <Rows
            data={data}
            sx={sx}
            variant={variant}
          />
        </TableBody>
      </Table>
    </TableContainer>
  )
}
